/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ImportSageIntacctDepartmentsInput = {|
  sageIntacctDepartmentIds?: ?$ReadOnlyArray<?number>,
  companyId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type ImportSageIntacctDepartmentsMutationVariables = {|
  input: ImportSageIntacctDepartmentsInput
|};
export type ImportSageIntacctDepartmentsMutationResponse = {|
  +importSageIntacctDepartments: ?{|
    +departments: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +sageIntacctId: ?string,
      |}
    |}>
  |}
|};
export type ImportSageIntacctDepartmentsMutation = {|
  variables: ImportSageIntacctDepartmentsMutationVariables,
  response: ImportSageIntacctDepartmentsMutationResponse,
|};
*/


/*
mutation ImportSageIntacctDepartmentsMutation(
  $input: ImportSageIntacctDepartmentsInput!
) {
  importSageIntacctDepartments(input: $input) {
    departments {
      node {
        id
        name
        sageIntacctId
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ImportSageIntacctDepartmentsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportSageIntacctDepartmentsPayload",
    "kind": "LinkedField",
    "name": "importSageIntacctDepartments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DepartmentTypeEdge",
        "kind": "LinkedField",
        "name": "departments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DepartmentType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportSageIntacctDepartmentsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportSageIntacctDepartmentsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ImportSageIntacctDepartmentsMutation",
    "operationKind": "mutation",
    "text": "mutation ImportSageIntacctDepartmentsMutation(\n  $input: ImportSageIntacctDepartmentsInput!\n) {\n  importSageIntacctDepartments(input: $input) {\n    departments {\n      node {\n        id\n        name\n        sageIntacctId\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0505f0cdfb914c50ed20cb9b85e0d683';

module.exports = node;
